<div
  (action)="redirect($event)"
  [error]="content.medallionBanner.error || content.menu.error"
  auraSkeletonLoader
>
  <div class="skymiles__wrapper">
    <div class="skymiles__wrapper__medallion">
      <div class="skymiles__wrapper__medallion__container">
        <div *ngIf="showAuraMedallionBanner; else machCoreMedallionBanner">
          <aura-medallion-banner
            (redirect)="redirect($event, '_blank')"
            (analytics)="onClickAnalytics($event)"
            *ngIf="!content.medallionBanner.disabled"
            [content]="content.medallionBanner"
          ></aura-medallion-banner>
        </div>
        <ng-template #machCoreMedallionBanner>
          <idp-medallion-banner
            (redirect)="redirect($event, '_blank')"
            (analytics)="onClickAnalytics($event)"
            *ngIf="!content.medallionBanner.disabled"
            [content]="content.medallionBanner"
          ></idp-medallion-banner>
        </ng-template>
      </div>
    </div>
    <idp-notification
      *ngIf="notification"
      [content]="notification"
      [target]="'skymiles__wrapper__medallion'"
    ></idp-notification>
    <div class="skymiles__wrapper__banner"></div>
    <div class="skymiles__wrapper__top">
      <div class="skymiles__wrapper__top--background-image"></div>
      <div class="skymiles__wrapper__top__container">
        <div class="skymiles__wrapper__top__container--left">
          <idp-menu
            *ngIf="!content.menu.disabled"
            [content]="content.menu"
            [accessToken]="accessToken"
          ></idp-menu>
        </div>
        <div class="skymiles__wrapper__top__container--content">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
